<section id="main-filters">
  <form [formGroup]="fgFilters">
    <div formGroupName="fgMainFilters">
      <div class="row">
        <div class="col-md-6">
          <label class="filter-title">Outside Diameter</label>
          <div class="position-relative">
            <ng-select
              class="slotted compact-select"
              placeholder="Select"
              clearAllText="Clear"
              [items]="filters?.OD"
              bindValue="id"
              bindLabel="text"
              formControlName="outsideDiameter"
              [loading]="isLoadingFilters"
            >
            </ng-select>
          </div>
        </div>
        <div class="col-md-6">
          <label class="filter-title">Wall Thickness (Weight)</label>
          <div class="position-relative">
            <ng-select
              class="slotted compact-select"
              placeholder="Select"
              clearAllText="Clear"
              [items]="filters?.WT"
              bindValue="id"
              bindLabel="text"
              formControlName="wallThickness"
              [loading]="isLoadingFilters"
            >
            </ng-select>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
